import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetMemberQuery } from "../../features/members/membersApi";
import { useGetProjectsQuery } from "../../features/projects/projectsApi";
import { useEditTaskMutation } from "../../features/tasks/tasksApi";

export default function EditTaskForm({ task }) {
  const [taskName, setTaskName] = useState(task.taskName);
  const [member, setMember] = useState(task.teamMember.id);
  const [projectName, setProjectName] = useState(task.project.id);
  const [deadline, setDeadline] = useState(task.deadline);

  const navigate = useNavigate();

  const { data: teams } = useGetMemberQuery();
  const { data: projects } = useGetProjectsQuery();

  const [
    editTask,
    { isSuccess: isEditTaskSuccess, isLoading: isEditTaskLoading },
  ] = useEditTaskMutation();

  useEffect(() => {
    if (isEditTaskSuccess) {
      navigate("/");
    }
  }, [isEditTaskSuccess, navigate]);

  const handleUpdate = (e) => {
    e.preventDefault();
    const teamMember = teams.filter((team) => team.id === Number(member));
    const project = projects.filter(
      (project) => project.id === Number(projectName)
    );
    const data = {
      taskName: taskName,
      deadline: deadline,
      teamMember: teamMember[0],
      project: project[0],
    };
    editTask({ id: task.id, data });
  };
  return (
    <form className="space-y-6" onSubmit={handleUpdate}>
      <div className="fieldContainer">
        <label htmlFor="lws-taskName">Task Name</label>
        <input
          type="text"
          name="taskName"
          id="lws-taskName"
          required
          placeholder="Implement RTK Query"
          value={taskName}
          onChange={(e) => setTaskName(e.target.value)}
        />
      </div>

      <div className="fieldContainer">
        <label>Assign To</label>
        <select
          name="teamMember"
          id="lws-teamMember"
          required
          value={member}
          onChange={(e) => setMember(e.target.value)}
        >
          <option value="" hidden>
            Select Job
          </option>
          {teams?.length >= 0 &&
            teams.map((team) => (
              <option value={team.id} key={team.id}>
                {team.name}
              </option>
            ))}
        </select>
      </div>
      <div className="fieldContainer">
        <label htmlFor="lws-projectName">Project Name</label>
        <select
          id="lws-projectName"
          name="projectName"
          required
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
        >
          <option value="" hidden>
            Select Project
          </option>
          {projects?.length >= 0 &&
            projects.map((project) => (
              <option value={project.id} key={project.id}>
                {project.projectName}
              </option>
            ))}
        </select>
      </div>

      <div className="fieldContainer">
        <label htmlFor="lws-deadline">Deadline</label>
        <input
          type="date"
          name="deadline"
          id="lws-deadline"
          required
          value={deadline}
          onChange={(e) => setDeadline(e.target.value)}
        />
      </div>

      <div className="text-right">
        <button type="submit" className="lws-submit">
          Update
        </button>
      </div>
      {isEditTaskLoading && (
        <div className="text-center" style={{ color: "red" }}>
          Updating Task....
        </div>
      )}
      {isEditTaskSuccess && (
        <div className="text-center" style={{ color: "red" }}>
          Update task successfully
        </div>
      )}
    </form>
  );
}
